import { Group } from 'three'
import { useNodeNeighborBaseFloorElevationReactiveMap } from '../../../rx/memo/useNodeNeighborBaseFloorElevationReactiveMap'
import type { Engine } from '../../core/engine/Engine.type'
import type { EntityGraphNode } from '../../core/engine/EntityGraphNode/EntityGraphNode.type'
import type { DeadwoodEntity } from '../../core/entity/EntityType/Deadwood'
import createDeadwoodTerrainClusterGroup from '../objects/Trees/Deadwood/createDeadwoodTerrainClusterGroup'

export default function createDeadwoodGroup(
  engine: Engine,
  ent: EntityGraphNode<DeadwoodEntity>,
  callback: (group: Group) => void
): void {
  const neighborBaseElevationReactiveMap = useNodeNeighborBaseFloorElevationReactiveMap(engine)
  createDeadwoodTerrainClusterGroup([ent], neighborBaseElevationReactiveMap).then(callback)
}
